import ApiHelper from '@/utils/api-helper'
import API from '@/constants/api'

class MetaService {
  static getMetas(limit = 100, page = 1) {
    return ApiHelper.fetch(`${API.URL + API.META}?pageSize=${limit}&page=${page}`)
  }

  static getMeta(id) {
    return ApiHelper.fetch(`${API.URL + API.META}/${id}`)
  }

  static getMetaByPath(path) {
    return ApiHelper.fetch(`${API.URL + API.META}/by-path${path}`)
  }

  static addMeta(meta) {
    return ApiHelper.fetch(`${API.URL + API.META}`, {
      method: 'POST',
      body: JSON.stringify({
        meta
      })
    })
  }

  static updateMeta(meta) {
    if (typeof meta._id === 'undefined') {
      return this.addMeta(meta)
    }

    return ApiHelper.fetch(`${API.URL + API.META}/${meta['_id']}`, {
      method: 'PUT',
      body: JSON.stringify({
        meta
      })
    })
  }

  static deleteMeta(id) {
    return ApiHelper.fetch(`${API.URL + API.META}/${id}`, {
      method: 'DELETE'
    })
  }
}

export default MetaService
